<template>
  <!-- 订单商品 -->
  <div class="orderShop" v-if="productInfo">
    <div class="orderShopTable">
      <ul class="shopTableTh">
        <li class="shopTableThP1">{{ $t("productInfo.col1") }}</li>
        <li class="shopTableThP2">{{ $t("productInfo.col2") }}</li>
        <li class="shopTableThP3">{{ $t("productInfo.col3") }}</li>
        <li class="shopTableThP4">{{ $t("productInfo.col4") }}</li>
        <li class="shopTableThP5">{{ $t("productInfo.col5") }}</li>
        <li class="shopTableThP6">{{ $t("productInfo.col6") }}</li>
        <li class="shopTableThP7">{{ $t("productInfo.col7") }}</li>
      </ul>
      <ul class="shopTableTd"  v-for="(item,index) in (productInfo.OrderProductsList)" :key="index">
        <li class="shopTableTdP1">
          <img class="shopImg" :src="item.ProductPhoto | imgUrlFilter"/>
          <div class="shopInfoName">{{item.ProductName}}</div>
        </li>
        <li class="shopTableTdP2"><span>{{item.ProductModelStr}}</span></li>
        <li class="shopTableTdP3" v-if="productInfo.State===0">{{ $t("productInfo.noState") }}</li>
        <li class="shopTableTdP3" v-else>{{productInfo.State | stateStrFilter(productInfo.State)}}</li>
        <li class="shopTableTdP4">{{item.Number}}</li>
        <li class="shopTableTdP5">{{item.C_CustomerIncome}}</li>
        <li class="shopTableTdP6">{{item.DiscountPrice}}</li>
        <li class="shopTableTdP7">
          <div class="shopTableTdP7Num">${{item.C_CustomerRecTotal}}</div>
          <div class="shopTableTdP7Freight">（{{ $t("productInfo.express") }}：${{item.Freight }}）</div>
        </li>
      </ul>
    </div>
    <!-- 实收款 -->
    <!-- <div class="collectionBox">实收款：<span class="collectionNum">{{productInfo.AllPrice}}</span>元</div> -->
  </div>
</template>
<script>
export default {
  name: 'OrderShop',
  props: ['productInfo'],
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
// 订单商品
.orderShop {
  margin-top: 20px;
  font-size: 13px;
  color: #333333;
  max-height: 380px;
  .orderShopTable {
    position: relative;
    .shopTableTh {
      list-style: none;
      margin: 0;
      padding: 0;
      background-color: #d9ebe7;
      text-align: center;
      height: 40px;
      line-height: 40px;
      display: flex;
      align-items: center;
      .shopTableThP1 {
        list-style: none;
        margin: 0;
        padding: 0;
        width: 27.4%;
      }
      .shopTableThP2 {
        list-style: none;
        margin: 0;
        padding: 0;
        width: 12.9%;
      }
      .shopTableThP3 {
        list-style: none;
        margin: 0;
        padding: 0;
        width: 8.4%;
      }
      .shopTableThP4 {
        list-style: none;
        margin: 0;
        padding: 0;
        width: 8.1%;
      }
      .shopTableThP5 {
        list-style: none;
        margin: 0;
        padding: 0;
        width: 9.1%;
      }
      .shopTableThP6 {
        list-style: none;
        margin: 0;
        padding: 0;
        width: 8.1%;
      }
      .shopTableThP7 {
        list-style: none;
        margin: 0;
        padding: 0;
        width: 25.2%;
      }
    }
    .shopTableTd {
      list-style: none;
      margin: 0;
      padding: 0;
      text-align: center;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #f0f0f0;
      li{
        border-left: 1px solid #f0f0f0;
        padding: 26px 0;
        box-sizing: border-box;
        &:nth-child(1){
          border: 0;
        }
      }
      .shopTableTdP1 {
        list-style: none;
        margin: 0;
        padding: 0;
        width: 27.4%;
        color: #333333;
        display: flex;
        align-items: center;
        .shopImg{
          width: 40%;
        }
        .shopInfoName{
          margin-left: 3%;
          text-align: left;
        }
      }
      .shopTableTdP2 {
        list-style: none;
        margin: 0;
        padding: 0;
        width: 12.9%;
        color: #999999;
      }
      .shopTableTdP3 {
        list-style: none;
        margin: 0;
        padding: 0;
        width: 8.4%;
        color: #25b9ff;
      }
      .shopTableTdP4 {
        list-style: none;
        margin: 0;
        padding: 0;
        width: 8.1%;
        color: #000000;
      }
      .shopTableTdP5 {
        list-style: none;
        margin: 0;
        padding: 0;
        width: 9.1%;
        color: #ff5852;
      }
      .shopTableTdP6 {
        list-style: none;
        margin: 0;
        padding: 0;
        width: 8.1%;
      }
      .shopTableTdP7 {
        list-style: none;
        margin: 0;
        padding: 0;
        width: 25.2%;
        color: #333333;
        font-weight: bold;
        .shopTableTdP7Num{
          margin-bottom: 10px;
        }
      }
    }
  }
  .collectionBox{
    font-size: 13px;
    color: #000000;
    margin-top: 10px;
    font-weight: bold;
    width: 100%;
    text-align: right;
    .collectionNum{
      color: #ff6862;
    }
  }
}
</style>
